<template>
  <div class="nx-editor"
       :class="{'nx-editor--treeview': hasTreeView}">
    <v-toolbar
      :id="id"
      color="nx-primary--darken-2"
      class="mt-5"
      extended
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      :scroll-off-screen="app"
      :scroll-threshold="60"
      fixed
      :app="app"
      tabs
      dark
      flat>

      <v-toolbar-title class="ml-0 pl-3">
        <slot name="title"></slot>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <slot name="metadata"></slot>

      <slot name="actions"></slot>

      <template slot="extension">
        <slot name="extension"></slot>
      </template>

    </v-toolbar>

    <v-container class="nx-container" fluid>
      <slot name="body"></slot>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'nx-editor',
  props: {
    app: {
      type: Boolean,
      default: true,
    },
    hasTreeView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    id() {
      return this.app ? 'nx-editor-header' : '';
    },
  },
};
</script>

<style lang="stylus">
@import '../../assets/stylus/variables.styl';
.nx-editor {
  background-color: $nx-primary--lighten-5;

  &--treeview {
    .nx-container {
      padding: 0;
      height: calc(100vh - 160px);
    }
  }

  .v-input:not(.v-input--switch) .v-label {
    color: $info;
  }

  .input-group__editor label {
    color: $info;
  }

  .nx-title {
    text-overflow: ellipsis
  }

  .v-toolbar__extension {
    position: relative;
  }

  .nx-container {
    margin-top: 48px;
  }
}

.v-content.nx-view {
  background-color: $nx-primary--lighten-5;

  .nx-content-editor {

    .container.nx-container {
      background-color: $nx-primary--lighten-5 !important;
    }

    .v-input:not(.v-input--switch) .v-label {
      color: $info;
    }

    .input-group__editor label {
      color: $info;
    }
  }
}
</style>
